import React, {useState, useRef} from 'react';
// import FaqStore from './flux/FaqStore';
// import { FontAwesomeIcon } from 'react-fontawesome'
// import { solid, regular, brands } from '@fortawesome/fontawesome-svg-core/import.macro' // <-- import styles to be used


export default function FAQpost(props) {
  const post = props.post;
  const postURL = `/blogs/faq/${post.handle}`;
  // console.log(post);
  const [showPost, setShowPost] = useState(false);
  // const [answerHeight, setAnswerHeight] = useState(false);
  const answerRef = useRef(null);

  // useEffect(() => {
  //   // console.log(answerRef.current.clientHeight);
  //   setAnswerHeight(answerRef.current.clientHeight);
  // }, [])

  function togglePost() {
    // console.log(`state: ${answerHeight} current: ${answerRef.current.clientHeight}`);
    showPost ? setShowPost(false) : setShowPost(true);
  }

  function renderHideButton() {
    return (
      <span>
        Hide Answer <i class="fa-solid fa-angles-up"></i>
      </span>
    )
  }
  function renderShowButton() {
    return (
      <span>
        Show Answer <i class="fa-solid fa-angles-down"></i>
      </span>
    )
  }

  // function checkTheHeight() {
  //   console.log(`answer height: ${answerHeight}`);
  // }

  function getHeightStyle() {
    // checkTheHeight();
    if (showPost) { 
      return { 
        "height": `${answerRef.current.clientHeight}px`,
        "opacity": "1",
      } 
    }
    return { "height": "0px" }
  }

  return (
    <li className="post">
      <hgroup>
        <h3
          onClick={(() => { togglePost() })}
        >
          {post.title}
        </h3>
        <div className="toggle">
          <button 
            onClick={() => { togglePost() }} 
            className="show-hide"
          >
            {showPost ? renderHideButton() : renderShowButton()}
          </button>
        </div>
      </hgroup>
      <div
        className="enclose"
        style={getHeightStyle()}
      >
        <div className="answer" ref={answerRef}>
          <div 
            className="post-content"
            dangerouslySetInnerHTML={{__html: post.body_html}}
          />
          <a
            href={postURL}
            className="blog-url"
          >
            <i class="fa-solid fa-up-right-from-square"></i>
          </a>
          
        </div>
      </div>
    </li>
  )
}